import { formatDate } from '@/helper'

export default {
  getData (state, _getters, _rootState, rootGetters) {
    const data = state.data

    if (!data.length) {
      return []
    }

    return data.map((item) => {
      return {
        ...item,
        statusName: item.isOpened ? 'Открыта' : 'Закрыта',
        openedByName: rootGetters['users/getData'].find(({ id }) => id === item.userIdOpened)?.name || '',
        closedByName: rootGetters['users/getData'].find(({ id }) => id === item.userIdClosed)?.name || '',
        openingAtFormatted: formatDate(item.openingAt),
        closingAtFormatted: item.closingAt ? formatDate(item.closingAt) : 'Смена еще не закрыта',
      }
    })
  },
  isDataLoaded (state) {
    return state.data.length > 0
  },
  getOpenedWorkingShift (state) {
    return state.data.filter(({ isOpened }) => isOpened).at(0)
  }
}